import { globalState } from "mfe-lib-bfo-shared";

const localeModules = import.meta.glob("../i18n/resources/*.ts");
// const allowZodFallback = import.meta.env.VITE_ALLOW_ZOD_FALLBACK === "true";
interface RuntimeConfig {
    VITE_API_BASE_URL: string;
    VITE_CHANNEL_REDIRECT_URL: string;
    VITE_DEFAULT_LANGUAGE: string;
    VITE_CIMODE_AVAILABLE: string;
    VITE_DEFAULT_TIMEOUT_MS: string;
    VITE_ANALYTICS_VENDOR: string;
    VITE_ANALYTICS_LOG: string;
    VITE_ANALYTICS_DATA_LAYER: string;
    VITE_FORCE_HIDE_TAC_MODEL: string;
    VITE_S3_BUCKET_URL: string;
    VITE_CPL_URL: string;
    VITE_ENABLE_LOG: string;
}

let runtimeConfig: RuntimeConfig | null = null;

export const AppConfig = {
    async load(): Promise<void> {
        const response = await fetch(`${import.meta.env.BASE_URL}config.json`);

        if (!response.ok) {
            console.log("[Test] Failed to load runtime configuration");
            return;
        }

        runtimeConfig = await response.json();

        globalState.update({
            VITE_ANALYTICS_VENDOR: runtimeConfig?.VITE_ANALYTICS_VENDOR,
            VITE_ANALYTICS_LOG: runtimeConfig?.VITE_ANALYTICS_LOG,
            VITE_ANALYTICS_DATA_LAYER: runtimeConfig?.VITE_ANALYTICS_DATA_LAYER,
            VITE_FORCE_HIDE_TAC_MODEL: runtimeConfig?.VITE_FORCE_HIDE_TAC_MODEL,
        });
    },
    getAvailableLanguages(): string[] {
        const languages = this.getTranslationLanguages();

        return languages;
    },

    getTranslationLanguages(): string[] {
        return Object.keys(localeModules)
            .map((path) => path.match(/\/([^/]+)\.ts$/)?.[1])
            .filter(Boolean) as string[];
    },

    async loadLanguageResource(lang: string) {
        const path = `../i18n/resources/${lang}.ts`;
        const loader = localeModules[path];

        if (!loader) {
            throw new Error(`Localization file for language "${lang}" not found.`);
        }

        const module = (await loader()) as {
            default: Record<string, unknown>;
        };

        return module.default;
    },

    getDefaultLanguage(): string {
        return runtimeConfig?.VITE_DEFAULT_LANGUAGE;
    },

    getIsCiModeAvailable(): boolean {
        const ciModeAllowed = runtimeConfig?.VITE_CIMODE_AVAILABLE === "true";

        return ciModeAllowed;
    },

    isAllowZodFallback(): boolean {
        return true;
    },

    getBaseUrl(): string {
        return runtimeConfig?.VITE_API_BASE_URL;
    },

    getChannelRedirectUrl(): string {
        return runtimeConfig?.VITE_CHANNEL_REDIRECT_URL;
    },

    getS3BucketUrl(): string {
        return runtimeConfig?.VITE_S3_BUCKET_URL;
    },

    getCplUrl(): string {
        return runtimeConfig?.VITE_CPL_URL;
    },

    getDefaultTimeoutMs(): string {
        return runtimeConfig?.VITE_DEFAULT_TIMEOUT_MS;
    },

    getEnableLog(): boolean {
        const enableLog = runtimeConfig?.VITE_ENABLE_LOG ? runtimeConfig?.VITE_ENABLE_LOG === "true" : true;

        return enableLog;
    },
};

export const modules = {
    cashliteApp: "cashlite-application",
    balanceTransferApp: "balance-transfer-application",
};
